import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useData } from './hooks/';

const PrivateRoute = ({ element: Component }) => {
  const { user, appIsReady } = useData();

  if (!appIsReady) {
    // 로딩 중일 때는 아무 것도 렌더링하지 않음
    return null;
  }

  return user ? Component : <Navigate to='/authentication/sign-in' />;
};

PrivateRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

export default PrivateRoute;
